import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDaily, useAudioLevel, useAudioTrack, useLocalSessionId } from '@daily-co/daily-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
  pageAtom,
  isAuthAtom,
  myNftAtom,
  myNftBackAtom,
  displayNameAtom,
  topMessageAtom,
  webcamAtom,
  showEditNameAtom,
} from '../../State';
import { format } from 'date-fns';
import { ReactComponent as AIWhite } from '../Images/buttons/aibutton.svg';
import { ReactComponent as AIBlack } from '../Images/buttons/selectModeAIBlack.svg';
import { ReactComponent as FaceWhite } from '../Images/buttons/faceButton.svg';
import { ReactComponent as FaceBlack } from '../Images/buttons/selectModeFaceBlack.svg';

import { ReactComponent as HatenaSVG } from '../Images/buttons/hatenaButton.svg';
import { ReactComponent as MoreSVG } from '../Images/buttons/moreButton.svg';
import './HairCheck.css';
import NFT from '../NFT/NFT';
import NFT2 from '../NFT/NFT2';
import NFTDetail from '../NFT/NFTDetail';
import DataModel from '../Util/DataModel';
import isElectron from '../../Global';
import ElectronMetaMask from '../ElectronMetaMask/ElectronMetaMask';
import Loading from '../Loading/Loading';
import NoMetaMask from '../ElectronMetaMask/NoMetaMask';
import NFTItem from '../NFT/NFTItem';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import MobileEditName from '../MobileTop/MobileEditName';
import FaceImage from '../Setting/FaceImage';
import NFTBack from '../NFT/NFTBack';

//ヘアーチェック
export default function HairCheck({
  joinCall,
  preAuthCompleteState,
  selectFace = false,
  liveData,
}) {
  //daily系
  const callObject = useDaily();

  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得
  let showThisNFT = roomID == 'makopt' || roomID == '144987874' ? true : false;

  //const localParticipant = useLocalParticipant(); //pre joinが完了したああとじゃないと値が取れない
  // const localSessionId = useLocalSessionId();
  // const audioTrack = useAudioTrack(localSessionId);

  //recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [webcamState, setWebcamState] = useRecoilState(webcamAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const setMyNftState = useSetRecoilState(myNftAtom);
  const setMyNftBackState = useSetRecoilState(myNftBackAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [showEditName, setShowEditName] = useRecoilState(showEditNameAtom);

  //その他
  const oldDisplayNameRef = useRef(null);
  const [loadingState, setLoadingState] = useState(false);
  const [noMetaMaskState, setNoMetaMaskState] = useState(false);
  const [noNameErrorState, setNoNameErrorState] = useState(false);
  const [hatenaState, setHatenaState] = useState(false);
  const { t, i18n } = useTranslation();

  //スケジュール系
  const [showScheduleState, setShowScheduleState] = useState(false);
  const [liveTitle, setLiveTitle] = useState(null);
  const [liveImage, setLiveImage] = useState(null);
  const [liveDateState, setLiveDateState] = useState(null);
  const [isEndState, setIsEndState] = useState(false);

  //初期化
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    initSchedule();
  }, [liveData]);

  //初期化
  const init = async (e) => {
    if (localStorage.getItem('displayName') != null) {
      oldDisplayNameRef.current = localStorage.getItem('displayName');
      setDisplayNameState(localStorage.getItem('displayName'));
    } else {
      //setDisplayNameState('Faceless');
    }

    if (localStorage.getItem('imageURL') != null) {
      setMyNftState(localStorage.getItem('imageURL'));
    } else {
      localStorage.setItem('imageURL', 'defaultkun');
      setMyNftState('defaultkun');
    }

    if (localStorage.getItem('nftID') == null) {
      localStorage.setItem('nftID', 'defaultkun');
    }

    if (localStorage.getItem('nftWhoCanUse') == null) {
      localStorage.setItem('nftWhoCanUse', 'anyone');
    }

    if (localStorage.getItem('backImageURL') != null) {
      setMyNftBackState(localStorage.getItem('backImageURL'));
    }

    if (localStorage.getItem('mode') != null) {
      if (localStorage.getItem('mode') == 'facial') {
        // setTimeout(() => {
        // }, 0);
        // setWebcamState(true);
      }
    }

    //認証
    if (localStorage.getItem('isAuth') != null && localStorage.getItem('isAuth')) {
      setAuthState(true);
    }

    //顔選択画面
    if (selectFace) {
      setPageState('nftList');
    }
  };

  //スケジュール会議用
  async function initSchedule() {
    if (liveData != null) {
      //現在時間
      let now = new Date();
      //開始時間
      let date = new Date(liveData?.liveDate?._seconds * 1000);

      //時間の差分
      const diff = date.getTime() - now.getTime(); // 時間の差を取得（ミリ秒）

      // ミリ秒から単位を修正
      const calcHour = Math.floor(diff / 1000 / 60 / 60);
      const calcMin = Math.floor(diff / 1000 / 60) % 60;
      const calcSec = Math.floor(diff / 1000) % 60;

      //まだ開始まで１時間以上ある場合
      if (calcHour > 1) {
        setShowScheduleState(true);
      } else {
        setShowScheduleState(false);
      }

      let formatDate;
      if (i18n.language == 'ja') {
        formatDate = format(
          date,
          'MM' + '月' + 'dd' + '日 ' + 'h' + '時' + 'mm' + '' + 'a' + ' 開始',
        );
      } else {
        formatDate = format(date, 'MMM do hh:mm a');
      }

      //日時の設定
      setLiveDateState(formatDate);

      //ステータス表示 (終了検知)
      if (liveData?.status != null && liveData?.status != 'active') {
        setIsEndState(true);
      }
    }
  }

  //ルームに参加
  const join = async (e) => {
    e.preventDefault();

    if (callObject == null) return;

    if (preAuthCompleteState == false) return;

    //名前の入力がない場合はエラー
    if (displayNameState == null || displayNameState == '') {
      if (isMobile) {
        setShowEditName(true);
        //参加成功のお知らせ
        setTopMessageState({
          type: 'joined',
          message: t('top.Type your display name'),
        });
      } else {
        setNoNameErrorState(true);
      }

      return;
    }

    //コールオブジェクトに名前を設定
    callObject.setUserName(displayNameState);

    //ローカルストレージ更新
    localStorage.setItem('displayName', displayNameState);

    //参加
    joinCall();

    //古い情報と違う場合のみ保存する
    if (oldDisplayNameRef.current != displayNameState && isAuthState && displayNameState != '') {
      DataModel.saveUserData('displayName', displayNameState);

      //エレクトロンの場合
      if (isElectron) {
        window.myapi.nameChange(displayNameState);
      }
    }
  };

  //ユーザー名を設定
  const onUserNameChange = (e) => {
    //フォームの値を更新
    setDisplayNameState(e.target.value);
  };

  useEffect(() => {
    if (callObject != null) {
      callObject.setUserName(displayNameState);
    }
  }, [displayNameState]);

  const toggleNFT = (e) => {
    e.preventDefault();
    setPageState('nftList');
  };

  const selectMode = (mode) => {
    if (mode == 'ai') {
      setWebcamState(false);
      localStorage.setItem('mode', 'ai');
    } else {
      setWebcamState(true);
      localStorage.setItem('mode', 'facial');
    }
  };

  const hatenaOver = async () => {
    setHatenaState(true);
  };

  const hatenaOut = async () => {
    setHatenaState(false);
  };

  //レンダー処理
  return (
    <>
      {/*ローディング*/}
      <Loading loadingState={loadingState} />
      {/*NFT選択画面*/}
      {pageState == 'nftList' && <>{showThisNFT ? <NFT2 /> : <NFT />}</>}
      {/*NFT詳細画面*/}
      {pageState == 'nftDetail' && <NFTDetail />}
      {/*背景*/}
      {pageState == 'background' && <NFTBack />}
      {/*エレクトロン用のメタマスクログイン*/}
      {pageState == 'electronMetaMask' && <ElectronMetaMask />}
      {/*メタマスクインストールして*/}
      {noMetaMaskState && <NoMetaMask setNoMetaMaskState={setNoMetaMaskState} />}
      {/*名前編集*/}
      {showEditName && <MobileEditName setShowEditName={setShowEditName} />}

      {/*スケジュール詳細ポップアップ*/}
      {showScheduleState && (
        <div className="scheduleBackWrap">
          <div id="liveWrap">
            <div
              id="recordVideoLeft"
              style={{ gridTemplateColumns: '70px 1fr', marginLeft: '0px' }}>
              <FaceImage myNftState={liveData?.liveImageURL} />
              <div>
                <div id="recordVideoTitle">{liveData?.liveTitle ?? 'Loading...'}</div>
                <div id="recordVideoDate">{liveDateState ?? '-- --- ---'}</div>
              </div>
            </div>
            <button className="scheduleCloseButton" onClick={() => setShowScheduleState(false)}>
              {t('setting.Close')}
            </button>
          </div>
        </div>
      )}

      {isMobile && (
        <button id="hairCheckMoileJoin" onClick={join}>
          {preAuthCompleteState ? (
            <>{t('haircheck.Join Now')}</>
          ) : (
            <>
              <div id="selectLoader">
                <svg className="circular-loader" viewBox="25 25 50 50">
                  <circle
                    className="loader-path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke="#70c542"
                    strokeWidth="2"
                  />
                </svg>
              </div>
            </>
          )}
        </button>
      )}

      {/*　参加ボタンエリア */}
      {selectFace == false && isMobile == false && (
        <div id="hairCheckWrap" style={{ opacity: pageState == 'nftList' ? 0.2 : 1 }}>
          <form className="hair-check" onSubmit={join}>
            {/* <h2>{t('haircheck.Ready to Start?')}</h2> */}

            {/*ディsプレイ名ラベル*/}
            <label htmlFor="username" className="hairCheckTitle">
              {t('haircheck.Display Name')}
            </label>

            {/* ディスプレイ名入力欄 */}
            <input
              name="username"
              type="text"
              placeholder={t('haircheck.Type Display Name')}
              onChange={(e) => onUserNameChange(e)}
              value={displayNameState ?? ''}
              // value=""
            />

            {/* エラーメッセージ */}
            {noNameErrorState && (
              <div id="hairCheckError">{t('haircheck.Value can’t be empty.')}</div>
            )}

            {/* <label htmlFor="username" className="hairCheckTitle">
              <>{t('haircheck.Select Avatar')}</>
            </label>
            <div id="hairCheckNFT">
              <NFTItem
                imageURL={'boy'}
                thumbURL={'images/nft/thumb/facelesskun.png'}
                type={'pro'}
                nftID="default"
              />

              <NFTItem
                imageURL={'sidegirl'}
                thumbURL={'images/nft/thumb/sidegirl.png'}
                type={'pro'}
                nftID="facelessgirl"
              />
              <NFTItem
                imageURL={'timeless'}
                thumbURL={'images/nft/thumb/timeless.png'}
                type={'pro'}
                nftID="ethereum-0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d-9899"
              />

              <div className="nftItem" onClick={toggleNFT}>
                <MoreSVG />
              </div>
            </div> */}

            <div className="electronLiveWrap" style={{ marginBottom: '0px' }}>
              {hatenaState && (
                <div className="electronLiveDetal">{t('haircheck.AI Mode is ...')}</div>
              )}
              <div className="electronLiveText" style={{ fontWeight: 'bold' }}>
                <>{t('haircheck.Tracking mode')}</>
              </div>
              <div className="electronHatena" onMouseEnter={hatenaOver} onMouseLeave={hatenaOut}>
                <HatenaSVG />
              </div>
            </div>

            <div id="selectModeWrap">
              <div
                className={!webcamState ? 'selectModeItem selected' : 'selectModeItem'}
                onClick={() => {
                  selectMode('ai');
                }}>
                <div className="selectModeIcon">{!webcamState ? <AIWhite /> : <AIWhite />}</div>
                <div className="selectModeTitle">
                  <>{t('haircheck.AI mode')}</>
                </div>
              </div>
              <div
                className={webcamState ? 'selectModeItem selected' : 'selectModeItem'}
                onClick={() => {
                  selectMode('face');
                }}>
                <div className="selectModeIcon">{!webcamState ? <FaceWhite /> : <FaceWhite />}</div>
                <div className="selectModeTitle">
                  <>{t('haircheck.Facial mode')}</>
                </div>
              </div>
            </div>
            {/* <div id="hairCheckNFT">
              <NFTItem
                imageURL={'boy'}
                thumbURL={'images/nft/thumb/facelesskun.png'}
                type={'pro'}
                nftID="default"
              />

              <NFTItem
                imageURL={'sidegirl'}
                thumbURL={'images/nft/thumb/sidegirl.png'}
                type={'pro'}
                nftID="facelessgirl"
              />
              <NFTItem
                imageURL={'timeless'}
                thumbURL={'images/nft/thumb/timeless.png'}
                type={'pro'}
                nftID="ethereum-0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d-9899"
              />

              <div className="nftItem" onClick={toggleNFT}>
                <MoreSVG />
              </div>
            </div> */}

            {/* 利用規約 */}
            {!isElectron && isAuthState == false && (
              <div id="hairCheckTerm">
                {t('haircheck.ByTerm')}
                <a href="https://faceless.ooo/terms" target={'_blank'}>
                  {t('haircheck.Terms')}
                </a>
              </div>
            )}

            {/* 参加ボタン */}
            <button onClick={join} type="submit" className="btBase">
              {preAuthCompleteState ? (
                <>{t('haircheck.Join Now')}</>
              ) : (
                <>
                  <div id="selectLoader">
                    <svg className="circular-loader" viewBox="25 25 50 50">
                      <circle
                        className="loader-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke="#70c542"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>
                </>
              )}
            </button>
          </form>
        </div>
      )}
    </>
  );
}
